import { ReactComponent as EyeIcon } from 'assets/icons/eyeIcon.svg';
import EyeSvgComponent from 'assets/icons/svg/EyeSvg/Eye';
import { LabelField } from "components";
import { CheckBox } from "components/CheckBox/CheckBox";
import Selection from "components/Selection/Selection";
import { convertUTCToLocalDate } from 'components/UTC/UtcConverter';
import FormGeneratorComponent from "helper/FormGenerator";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from 'helper/numberFormat';
import React, { useEffect, useRef, useState } from 'react';
import { ReserveLoginButton } from "../../ClassInfo/Theme";
import { defaultRequiredFields } from "../requiredFields";
import { memberAnswers } from "./memberAnswers";
import Products from "./Products/Products";
import { ProductWrapper, TicketContent, TicketName, TicketOptionsHeader, TicketOptionsSelection, TicketTitle, TicketWrapper, ValidationIcon, ValidationItems, ValidationWrapper } from './Theme';

const Ticket = ({
  formik,
  allowAppToAllTickets,
  applyToAllTickets,
  classes,
  openClassInfoModal,
  selectedClass,
  setSelectedClass,
  ticketId,
  currentFormData,
  updatedFormDataHandler,
  answerFormData,
  productsData,
  errors = [],
  currentClass,
  familyMembers = [],
  isFamilyMemberLoading,
  handleFamilyMemberSearch,
  handleFamilyMemberScroll,
  isAuth,
  setApplySelectedFamilyMember,
  disabledAppToAllTickets,
  applyInformationHandler,
  activeTicket,
  reserveLoginButton,
  handleReserveLogin,
  currentFormReservation,
  onSelectClass,
  removeSelectedClass,
  removeFamilyMember
}) => {
  const [selectedFamilyMember, setSelectedFamilyMember] = useState(null);
  const formKey = (currentFormData || []).map((field) => field.field_name || field.id).join("\n");
  const prevForm = useRef({ ticketId, formKey });
  const [formData, setFormData] = useState([
    ...(defaultRequiredFields || []),
  ]);

  const memberPortal = localStorage.getItem('memberPortal') === 'true' || false;


  const applyInformationToAllTickets = () => {
    if (disabledAppToAllTickets) return;
    applyInformationHandler();
  }

  const onClassChange = (value) => {
    if (!value) {
      setSelectedClass(null);
      removeSelectedClass(ticketId);
      return;
    }
    setSelectedClass(value);
    onSelectClass({
      ticketId: ticketId,
      classDetails: value,
    })
  };

  const incrementProductCounter = (productId) => {
    const updatedProductsData = productsData.map((product) => {
      if (product._id === productId) {
        return {
          ...product,
          counter: product.counter + 1,
          selectedVariants: product.variant ? [...product.selectedVariants, ""] : product.selectedVariants,
          totalCount: product.variant ? product.totalCount : product.totalCount + 1,
          totalAmount: product.variant ? product.totalAmount : product.totalAmount + product.amount,
        };
      }
      return product;
    });
    formik.setFieldValue(`registrationForm.${activeTicket}.products`, updatedProductsData);
  };

  const decrementProductCounter = (productId) => {
    const updatedProductsData = productsData.map((product) => {
      if (product._id === productId) {
        const lastSelectedVariant = product.selectedVariants[product.selectedVariants.length - 1];

        return {
          ...product,
          counter: Math.max(product.counter - 1, 0),
          selectedVariants: product.variant ? product.selectedVariants.slice(0, -1) : product.selectedVariants,
          variantInfo: product.variant ? product.variantInfo.map((variant) => {
            if (variant.counterVariant > 0 && lastSelectedVariant === variant.name) {
              return {
                ...variant,
                counterVariant: variant.counterVariant - 1
              };
            }
            return variant;
          }) : product.variantInfo,
          totalCount: product.variant ? (lastSelectedVariant ? Math.max(product.totalCount - 1, 0) : product.totalCount) : Math.max(product.totalCount - 1, 0),
          totalAmount: product.variant ? (lastSelectedVariant ? product.totalAmount - product.variantInfo.find(variant => variant.name === lastSelectedVariant).amount : product.totalAmount) : Math.max(product.totalAmount - product.amount, 0),
        };
      }
      return product;
    });
    formik.setFieldValue(`registrationForm.${activeTicket}.products`, updatedProductsData);
  }

  const selectProductVariant = (value, productId, currentCounter) => {
    const updatedProductsData = productsData.map((product) => {
      if (product._id === productId && product.variant) {
        const updatedSelectedVariants = [...product.selectedVariants];
        updatedSelectedVariants[currentCounter] = value;
        const updatedVariantInfo = product.variantInfo.map((variant) => {
          const count = updatedSelectedVariants.filter((v) => v === variant.name).length;
          return {
            ...variant,
            counterVariant: count,
          };
        });
        const updatedTotalAmount = updatedVariantInfo.reduce((sum, variant) => sum + (variant.amount * variant.counterVariant), 0);
        return {
          ...product,
          variantInfo: updatedVariantInfo,
          selectedVariants: updatedSelectedVariants,
          totalCount: updatedSelectedVariants.filter((v) => v).length,
          totalAmount: updatedTotalAmount,
        };
      }
      return product;
    });
    formik.setFieldValue(`registrationForm.${activeTicket}.products`, updatedProductsData);
  }


  useEffect(() => {
    if (!currentFormData?.length) return;
    const updatedFormData = currentFormData.length > 0 && currentFormData.map((item, i) => {
      if (item?.options) {
        return {
          ...item,
          options: item?.options?.map((val) => {
            return {
              ...val,
              key: `${val.key}_${ticketId}`,
            }
          })
        }
      } else {
        return {
          ...item,
        }
      }
    })
    setFormData(updatedFormData)
  }, [currentFormData])

  // Class switched on the same enrollment with a child already chosen: refill that class's fields.
  // Skips first render and enrollment-tab switches so typed answers are not overwritten.
  useEffect(() => {
    const prev = prevForm.current;
    prevForm.current = { ticketId, formKey };
    const member = currentFormReservation?.selectedMember;
    if (!member || prev.ticketId !== ticketId || prev.formKey === formKey || !currentFormData?.length) return;
    const birthValue = member.date_of_birth
      ? formatDate({ date: convertUTCToLocalDate(member.date_of_birth), formatType: "default" })
      : "";
    updatedFormDataHandler(memberAnswers(member, currentFormData, answerFormData, birthValue), ticketId, currentFormData, member);
    // deps: formKey/ticketId only, answerFormData here would refill on every keystroke
  }, [formKey, ticketId])

  const syncValuesWithFormik = (form) => {
    updatedFormDataHandler(form, ticketId, currentFormData);
  }

  const onFamilyMemberChange = async (value) => {
    setSelectedFamilyMember(value);
    if(!value) {
      removeFamilyMember(ticketId);
      return;
    }
    if (value) {
      const birthValue = value.date_of_birth
        ? formatDate({ date: convertUTCToLocalDate(value.date_of_birth), formatType: "default" })
        : "";
      const updatedAnswerFormData = memberAnswers(value, currentFormData, answerFormData, birthValue);
      updatedFormDataHandler(updatedAnswerFormData, ticketId, currentFormData, value);
      setApplySelectedFamilyMember((prev) => (!prev));
    }
  }

  const customFormatOptionLabel = (item) => {
    const {class_name, class_pricing, _id} = item;
    const handleEyeClick = (e) => {
      e.stopPropagation();
      openClassInfoModal(item, ticketId);
    };

    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-between">
          <div className="name-container">
            <div>{class_name} - {numberFormat({number: class_pricing?.total_cost, decimal:2, style: 'currency'})}</div>
          </div>
          <EyeSvgComponent 
            fill="#2555ef"
            onClick={handleEyeClick}
          />
        </div>
      </div>
    );
  };

  return (
    <TicketWrapper>
      <TicketContent>
        {errors?.length > 0 &&
          <ValidationWrapper>
            <ValidationIcon />
            <ValidationItems>
              {errors?.map((error) => (
                <li key={error.errorMessage}>{error.errorMessage}</li>
              ))}
            </ValidationItems>
          </ValidationWrapper>
        }
        <TicketOptionsHeader>
          <TicketOptionsSelection>
            <LabelField
              mandatory={true}
              title={"Select class"}
            />
            <Selection
              name="classes"
              mandatory={true}
              placeholder="Select Class"
              options={classes?.map((item) => ({
                ...item,
                label: item?.class_name,
              }))}
              isLoading={false}
              onChange={(value) => {
                onClassChange(value);
              }}
              value={selectedClass || currentClass || null}
              isClearable={selectedClass || currentClass ? true : false}
              style={"secondary"}
              customFormatOptionLabel={customFormatOptionLabel}
            />
          </TicketOptionsSelection>
          {isAuth ? (
            <TicketOptionsSelection>
              <LabelField
                mandatory={false}
                title={"Select family member"}
              />
              <Selection
                name="familyMember"
                mandatory={false}
                placeholder="Select Family Member"
                options={familyMembers.map((member) => ({
                  value: member.id || member._id,
                  label: `${member.firstName || member.first_name || ''} ${member.lastName || member.last_name || ''}`.trim(),
                  ...member
                }))}
                isLoading={isFamilyMemberLoading}
                onChange={(value) => {
                  onFamilyMemberChange(value);
                }}
                value={selectedFamilyMember || currentFormReservation?.selectedMember || null}
                isClearable={true}
                style={"secondary"}
                onInputChange={handleFamilyMemberSearch}
                onMenuScrollToBottom={handleFamilyMemberScroll}
              />
            </TicketOptionsSelection>
          ) : memberPortal ? (
            <ReserveLoginButton onClick={handleReserveLogin}
              style={{
                marginTop: "25px"
              }}
            >
              {reserveLoginButton}
            </ReserveLoginButton>
          ) : null
          }
        </TicketOptionsHeader>
        {allowAppToAllTickets &&
          <CheckBox text="Apply the information to all enrollments"
            onChange={applyInformationToAllTickets}
            checked={applyToAllTickets}
            disabled={disabledAppToAllTickets}
          />
        }
        <br />
        {(formData?.length > 0) && (
          <FormGeneratorComponent
            key={ticketId}
            formStructure={[...formData]}
            syncValuesWithFormik={syncValuesWithFormik}
            answerData={answerFormData}
          />
        )}
        {productsData?.length > 0 &&
          <ProductWrapper>
            <h3>
              Select optional add-ons below
            </h3>
            <Products
              productsData={productsData}
              incrementProductCounter={incrementProductCounter}
              decrementProductCounter={decrementProductCounter}
              selectProductVariant={selectProductVariant}
            />
          </ProductWrapper>
        }
      </TicketContent>
    </TicketWrapper>
  )
}

export default Ticket